import { TraceLoggingHelpers } from "../../helpers/trace-logging-helpers";

export class DrawingToolsSettingModel {
    
    private settingDict: any = {};

    constructor(data?: any) {
        if (data?.settingDict) {
            this.settingDict = data.settingDict;
        }
    }

    public get(key: string): any {
        if (!key) {
            return null;
        }
        
        return this.settingDict[key];
    }

    public update(annotation: any) {
        if (!annotation?.options) {
            return;
        }

        const key = annotation.options.langKey;
        const opt: any = {
            typeOptions: null,
            labelOptions: null
        };
        
        if (annotation.options.typeOptions?.line) {
            opt.typeOptions = {
                line: {
                    stroke: annotation.options.typeOptions.line.stroke,
                    fill: annotation.options.typeOptions.line.fill,
                    strokeWidth: annotation.options.typeOptions.line.strokeWidth
                },
            };
        }

        if (annotation.options.labelOptions) {
            opt.labelOptions = {
                backgroundColor: annotation.options.labelOptions.backgroundColor,
                style: {
                    color: annotation.options.labelOptions.style.color,
                    fontSize: annotation.options.labelOptions.style.fontSize
                }
            }
        }

        this.settingDict[key] = opt;
        // TraceLoggingHelpers.log('saveSettings settingDict', this.settingDict)
    }
}